import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
} from "react-admin";
 
const UserShow = () => (
  <Show title="User Details">
    <SimpleShowLayout >
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="email" />
      <TextField source="scope_reference" />
 
      <BooleanField source="is_active" />
 
      <DateField source="last_login_at" showTime />
      <DateField source="created_at" showTime />
 
      <TextField source="created_by" />
    </SimpleShowLayout>
  </Show>
);
 
export default UserShow;
